import { ToastContainer, toast } from "react-toastify";
import Menu from "../../components/menu";
import Footer from "../../components/footer";
import { authApi } from "../../services/api/api";
import useAuth from "../../hooks/useAuth";
import styles from './styles.module.css'

import { useQuery, keepPreviousData } from "@tanstack/react-query"
import { useRef, useState } from "react";

import IconButton from '@mui/material/IconButton';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import User from "../../components/user";

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Switch from '@mui/material/Switch';
import SkeletonUsers from "../../components/skeletons/user";
import { ImageIcon, Search, UserRoundPlus, X } from "lucide-react";

export default function Usuarios() {

    const api = authApi()

    const { user, theme } = useAuth()

    const [page, setPage] = useState(1)

    const [newUser, setNewUser] = useState(false)

    const [search, setSearch] = useState('')

    const [file, setfile] = useState('')

    const [image, setImage] = useState('')

    const [name, setName] = useState('')

    const [email, setEmail] = useState('')

    const [password, setPassword] = useState('')


    const [checked, setChecked] = useState(false);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked(event.target.checked);
    };


    const { data } = useQuery(
        {
            queryKey: ['usuarios', page, search, newUser, handleDelete],
            queryFn: () => api.usuarios(search, page),
            // placeholderData:keepPreviousData, 
            // staleTime: 5 * 60 * 1000
        }
    )

    function handleSetPage() {
        if (page < data?.last_page) {
            setPage(page + 1)
        }
    }

    async function handleAddUser() {
        setOpen(true)
    }

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    let inputRef = useRef<HTMLInputElement>(null)

    function handleImg() {
        if (inputRef) {
            inputRef.current?.click()
        }
    }

    function handleFile(e: React.ChangeEvent<HTMLInputElement>) {
        const selectedFiles = e.target.files as FileList

        if (selectedFiles?.[0].size > 1048576) {
            toast.error('A imagem não pode ultrapassar 1mb.', { theme: 'dark', toastId: 'password' })
            return
        }

        setfile(URL.createObjectURL(selectedFiles?.[0]))

        if (e.target.files) {

            const files = e.target.files[0]

            const reader = new FileReader()
            reader.readAsBinaryString(e.target.files[0])
            reader.onload = (ev: any) => {
                setImage(`data:${files.type};base64,${btoa(ev.target.result)}`)
            }
        }
    }

    async function handleSave() {

        if (name === '' || email === '' || password === '') {
            toast.error('Preencha todos os dados.', { theme: 'dark', toastId: 'dados' })
            return
        }
        toast.loading('carregando.', { theme: 'dark', toastId: 'loadingUser' })
        const data = {
            'name': name,
            'email': email,
            'password': password,
            'admin': checked,
            'img': image,

        }
        const response = await api.setUser(data)

        toast.dismiss('loadingUser')
        if (response === 200) {
            handleClose()
            setNewUser(!newUser)
            toast.success('Usuário cadastrado com sucesso.', { theme: 'dark', toastId: 'succesUser' })
        } else {
            toast.error('Ocorreu algum erro tente novamente mais tarde.', { theme: 'dark', toastId: 'errorUser' })
        }

    }

    async function handleDelete(id: number) {

        toast.loading('Preencha todos os dados.', { theme: 'dark', toastId: 'deleteUser' })

        const response = await api.deleteUser(id)

        if (response === 200) {
            setNewUser(!newUser)
            toast.dismiss('deleteUser')
            toast.success('Usuário deletado com sucesso.', { theme: 'dark', toastId: 'succesDeleteUser' })
        } else {
            toast.dismiss('deleteUser')
            toast.error('Ocorreu algum erro tente novamente mais tarde.', { theme: 'dark', toastId: 'errorUser' })
        }
    }

    return (
        <div className={`main w-screen bg-gray-100 ${theme}`}>
            <Menu />
            <div className={`${theme} min-h-screen w-full flex justify-center transition-all duration-500 ${theme === 'dark' ? 'dark:bg-[#061c3f]' : 'bg-gray-50'}`}>
                <div className="w-full max-w-[1850px] px-4 sm:px-8 py-10 flex flex-col items-center">

                    {/* CABEÇALHO */}
                    <div className="w-full  mb-4 flex flex-col gap-4">
                        <div className="flex justify-between items-end border-b border-gray-200 dark:border-white/10 pb-4">
                            <div className="flex flex-col justify-center gap-1">
                                <h4 className="text-slate-400 dark:text-slate-500 text-[10px] font-bold uppercase tracking-[0.3em]">
                                    Administrador
                                </h4>
                                <h2 className="text-xl font-bold text-slate-800 dark:text-white tracking-tight">
                                    Gestão de Usuários
                                </h2>

                            </div>

                            <button
                                onClick={handleAddUser}
                                className="flex items-center gap-2 bg-blue3 hover:bg-blue4 text-white px-5 py-2.5 rounded-2xl  transition-all active:scale-95 text-sm font-bold uppercase tracking-wider"
                            >
                                <UserRoundPlus size={17} />
                                <span className="hidden sm:inline">Novo Usuário</span>
                            </button>
                        </div>


                    </div>
                    {/* BARRA DE PESQUISA REFINADA */}

                    {/* LISTA DE USUÁRIOS (CARD PRINCIPAL) */}
                    <div className="w-full dark:border-0 dark:shadow-none  shadow-2xl shadow-blue-900/5 overflow-hidden mb-6">
                        <div className="relative w-full sm:w-96 group mb-2">
                            <div className="absolute inset-y-0 left-3 flex items-center text-gray-400 group-focus-within:text-blue-500 transition-colors">
                                <Search size={17} />
                            </div>
                            <input
                                type="text"
                                placeholder="Pesquisar por nome ou e-mail..."
                                className="placeholder:text-sm w-full pl-11 pr-4 py-3 rounded-2xl bg-white dark:bg-white/5 border border-gray-200 dark:border-white/5 text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-blue-500/50 transition-all shadow-sm placeholder:text-gray-400"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                            />
                        </div>
                        <div className="flex flex-col mb-5">
                            {data ? (
                                <div className="divide-y divide-gray-50 dark:divide-transparent space-y-4">
                                    {data.data.map((item: any) => (
                                        <User
                                            key={item.id}
                                            user={item}
                                            handleDelete={handleDelete}
                                            newUser={newUser}
                                            setNewUser={setNewUser}
                                        />
                                    ))}
                                </div>
                            ) : (
                                <div className="p-8">
                                    <SkeletonUsers />
                                </div>
                            )}
                        </div>

                        {/* PAGINAÇÃO REBOTADA */}
                        <div className="px-8 py-6 bg-gray-50/50 dark:rounded-2xl dark:bg-white/5 flex flex-col sm:flex-row gap-4 items-center justify-between border-t border-gray-100 dark:border-white/5">
                            <span className="text-xs font-bold uppercase tracking-widest text-gray-400">
                                Página atual <span className="text-blue-600 dark:text-blue-400">{page}</span> de {data?.last_page || 1}
                            </span>

                            <div className="flex gap-2">
                                <button
                                    disabled={page === 1}
                                    onClick={() => setPage((old) => Math.max(old - 1, 1))}
                                    className="flex items-center gap-2 px-4 py-2 rounded-xl bg-white dark:bg-[#061c3f] text-gray-600 dark:text-gray-300 border border-gray-200 dark:border-white/5 hover:bg-gray-100 dark:hover:bg-blue-900/20 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-xs font-black uppercase tracking-widest"
                                >
                                    <ArrowBackIosNewIcon style={{ fontSize: '14px' }} />
                                    <span className="hidden sm:inline">Anterior</span>
                                </button>

                                <button
                                    disabled={page === data?.last_page}
                                    onClick={handleSetPage}
                                    className="flex items-center gap-2 px-4 py-2 rounded-xl bg-white dark:bg-[#061c3f] text-gray-600 dark:text-gray-300 border border-gray-200 dark:border-white/5 hover:bg-gray-100 dark:hover:bg-blue-900/20 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-xs font-black uppercase tracking-widest"
                                >
                                    <span className="hidden sm:inline">Próxima</span>
                                    <ArrowForwardIosIcon style={{ fontSize: '14px' }} />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    style: {
                        borderRadius: '32px',
                        backgroundImage: 'none',
                        overflow: 'hidden',
                        width: '100%',
                        maxWidth: '450px'
                    },
                }}
            >
                {/* CABEÇALHO COM GRADIENTE */}
                <div className="bg-gradient-to-r from-blue3 to-blue4 px-6 py-6 flex justify-between items-center shadow-lg">
                    <div className="flex items-center gap-3">
                        <div className="bg-white/10 p-2.5 rounded-xl backdrop-blur-md">
                            <UserRoundPlus className="text-white" />
                        </div>
                        <div>
                            <h2 className="text-lg font-bold text-white tracking-tight">Novo Usuário</h2>
                            <p className="text-blue-100 text-[10px] uppercase tracking-widest font-medium">Acesso ao Sistema</p>
                        </div>
                    </div>
                    <button onClick={handleClose} className="text-white/50 hover:text-white transition-colors">
                        <X size={20} />
                    </button>
                </div>

                <DialogContent className="pt-8">
                    <div className="flex flex-col gap-6">

                        {/* SEÇÃO DA FOTO CIRCULAR */}
                        <div className="flex flex-col items-center gap-2">
                            <div
                                onClick={handleImg}
                                className="relative group w-24 h-24 rounded-full bg-gray-100 dark:bg-white/5 border-2 border-dashed border-gray-200 dark:border-white/10 flex justify-center items-center cursor-pointer overflow-hidden transition-all hover:border-blue-500 shadow-inner"
                            >
                                {image ? (
                                    <img src={image} alt="Preview" className="w-full h-full object-cover transition-transform group-hover:scale-110" />
                                ) : (
                                    <div className="flex flex-col items-center text-gray-400">
                                        <ImageIcon fontSize="small" />
                                        <span className="text-[9px] font-bold uppercase mt-1">Foto</span>
                                    </div>
                                )}
                                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                                    <span className="text-[10px] text-white font-bold uppercase">Upload</span>
                                </div>
                            </div>
                            <input name="image" type="file" accept="image/*" className="hidden" ref={inputRef} onChange={handleFile} />
                        </div>

                        {/* CAMPOS DE INPUT ESTILIZADOS */}
                        <div className="flex flex-col gap-4">
                            <div className="flex flex-col gap-1.5">
                                <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-2">Nome Completo</label>
                                <input
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    type="text"
                                    placeholder="Ex: João Silva"
                                    className="w-full p-3.5 rounded-2xl bg-gray-50 dark:bg-[#061c3f] border border-gray-100 dark:border-white/5 text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-blue-500 transition-all shadow-inner"
                                />
                            </div>

                            <div className="flex flex-col gap-1.5">
                                <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-2">E-mail</label>
                                <input
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    type="email"
                                    placeholder="exemplo@email.com"
                                    className="w-full p-3.5 rounded-2xl bg-gray-50 dark:bg-[#061c3f] border border-gray-100 dark:border-white/5 text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-blue-500 transition-all shadow-inner"
                                />
                            </div>

                            <div className="flex flex-col gap-1.5">
                                <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-2">Senha Provisória</label>
                                <input
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    type="password"
                                    placeholder="••••••••"
                                    className="w-full p-3.5 rounded-2xl bg-gray-50 dark:bg-[#061c3f] border border-gray-100 dark:border-white/5 text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-blue-500 transition-all shadow-inner"
                                />
                            </div>

                            {/* TOGGLE ADMINISTRADOR */}
                            <div className="flex items-center justify-between p-3.5 bg-blue5/5 rounded-2xl border border-blue4/10 rounded-2xl border border-gray-100 dark:border-white/5 mt-2">
                                <div className="flex flex-col">
                                    <span className="text-sm font-bold text-blue2 ">Perfil Administrador
                                    </span>
                                    <span className="text-[10px] text-blue5  uppercase font-bold tracking-tighter">Permite gerenciar o acervo</span>
                                </div>
                                <Switch
                                    checked={checked}
                                    onChange={handleChange}
                                    color="primary"
                                />
                            </div>
                        </div>
                    </div>
                </DialogContent>

                <DialogActions className="p-8 pt-4">
                    <div className="p-3 w-full">
                        <button
                            onClick={handleSave}
                            className="w-full h-14 bg-gradient-to-r from-blue-600 to-blue-800 hover:from-blue-700 hover:to-blue-900 text-white font-black rounded-2xl shadow-xl shadow-blue-500/20 uppercase tracking-widest text-xs transition-all active:scale-[0.98] flex items-center justify-center gap-2"
                        >
                            Cadastrar Usuário
                        </button>
                    </div>
                </DialogActions>
            </Dialog>

            <ToastContainer />
            {/* <Footer/> */}
        </div>
    )
}